import { defineProvider } from '@nuxt/image/runtime'

// TODO: Extend this to handle more cases, now it just uses the abs image provided
export default defineProvider({
  getImage(src) {
    return { url: src }
  },
})
